import React from "react";
const ErrorIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "28", height: "28", viewBox: "0 0 28 28", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#F64D43" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M9.333 18.148C4.46 18.148.52 14.208.52 9.333.519 4.46 4.459.52 9.333.52c4.874 0 8.815 3.94 8.815 8.814 0 4.874-3.94 8.815-8.815 8.815zm0 0c4.874 0 8.815-3.94 8.815-8.815 0-4.874-3.94-8.814-8.815-8.814C4.46.519.52 4.459.52 9.333c0 4.874 3.94 8.815 8.814 8.815zM9.333 4.148L9.333 11.407M9.333 13.481L9.333 14.519",
    transform: "translate(4.667 4.667)"
  }
)));
var errorIcon_default = ErrorIcon;
export {
  errorIcon_default as default
};
//# sourceMappingURL=errorIcon.js.map
